import { LoadState } from "../../constants/enums";
import { IFeeTransition, IStudent, IStudentState } from "./student.types";

export const defaultFeeTransaction: IFeeTransition = {
  fee_transaction_id: 0,
  fee_transaction_unique_id: 0,
  fee_transaction_uuid: "",
  opportunity_uuid: "",
  customer_fact_uuid: null,
  customer_name: null,
  fees_paid: 0,
  remarks: null,
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
};

export const defaultStudent: IStudent = {
  company_outlet_uuid: "",
  company_outlet_name: "",
  contact_number: "",
  customer_code: "",
  customer_personal_information_id: 0,
  customer_personal_information_unique_id: 0,
  customer_personal_information_uuid: "",
  customer_fact_uuid: "",
  salutation: null,
  customer_name: "",
  goes_by: "",
  position: null,
  mobile: null,
  country_code: null,
  country_iso_code: null,
  contact_number_one: "",
  contact_number_two: null,
  phone_ext: null,
  email: "",
  status: "ACTIVE",

  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
  assigned_to: null,
  docs_upload: null,

  // Missing values added with null
  inquiry_date: null,
  name_of_guest: "",
  first_name: "",
  last_name: "",
  date_of_birth: null,
  gender: "MALE",
  permanent_address: null,
  caste_category: null,
  city: null,
  state: null,
  pincode: null,
  country: null,
  address_line1: null,
  address_line2: null,
  inquiry_reference: null,
  followUp_date_and_remark: null,
  father_name: null,
  mother_name: null,
  annual_income: null,
  package_structure: null,
  family_income: null,
  aadhar_no: null,
  remarks: "",
  additional_fields: null,
  customer_relative: [],
  customer_visit_status: "INQUIRY",
};

export const defaultStudentState: IStudentState = {
  list: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  student: {
    data: defaultStudent,
    loading: LoadState.NotLoaded,
    error: null,
  },
  guestVisitHistory: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  feeTransitionlist: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  feeTransition: {
    data: defaultFeeTransaction,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
